module.exports = __webpack_public_path__ + "img/close.fd196325.svg";